module.exports = __webpack_public_path__ + "img/fujiwara no mokou_lw.19712316.png";